<template>
	<div id="sticky-text-wrap">
		<template v-for="(segment, index) in props.textContent" :key="index">
			<span :class="{ 'no-wrap': segment.noWrap }">
				<template v-for="(content, indexB) in segment.content" :key="`content_${indexB}`">
					<span v-if="typeof content == 'string'" :key="`content_${indexB}`" v-html="content" />
					<span
						v-if="typeof content == 'object' && content.className && content.text"
						:class="content.className"
						v-html="content.text"
					/>
					<slot
						v-if="typeof content == 'object' && content.slotName"
						:name="content.slotName"
					/>
				</template>
			</span>
		</template>
	</div>
</template>

<script setup>

defineOptions({
	name: 'SearchFilters'
});

const props = defineProps({
	textContent: {
		type: Array,
		default: () => ([
			{
				noWrap: false,
				//pass an object at any index to render the slotted element
				// {
				// 	slotName: 'NameOfSlot'
				// }
				content: ['']
			}
		])
	}
});
</script>
<style lang="less">
#sticky-text-wrap {
	white-space: normal;
	*::after {
		content: '';
	}
	> span::after {
		content: ' ';
	}
	*[class*="afis-icon"]::after {
		content: ' ';
		font-size: 0.666em;
	}
	.no-wrap {
		white-space: nowrap;
	}
}
</style>
